<!-- close button -->
<button mat-dialog-close class="close-button" tabindex="-1"></button>

<!-- dialog title -->
<h2 class="questionarysave">Save and Continue Later</h2>

<!-- form -->
<form [formGroup]="form" name="emailForm">

    <!-- dialog content -->
    <mat-dialog-content class="questionarysave">

        <!-- instructions -->
        <h3>
            Please enter your email address, and you will receive a message with a link to the location you have saved. If you don't receive the message, check your spam folder.
        </h3>

        <!-- form fields -->
        <mat-form-field>
            <input placeholder="Enter Email Address" matInput autofocus required formControlName="email" name="email" autocomplete="off" maxlength="255">
            <mat-error *ngIf="this.form.controls.email.hasError('required')">A Valid Email Address Is Required!</mat-error>
            <mat-error *ngIf="this.form.controls.email.hasError('email')">Not a Valid Email Address!</mat-error>
        </mat-form-field>
        <mat-form-field>
            <input placeholder="Confirm Email Address" matInput required class="form-control" formControlName="confirmemail" name="confirmemail" autocomplete="off" maxlength="255">
            <mat-error *ngIf="this.form.controls.confirmemail.hasError('required')">A Valid Email Address Is Required!</mat-error>
            <mat-error *ngIf="this.form.controls.confirmemail.hasError('email')">Not a Valid Email Address!</mat-error>
        </mat-form-field>
        <div><mat-error *ngIf="this.form.errors?.emailMismatch">Email Addresses do not match!</mat-error></div>

        <!-- buttons -->
        <mat-dialog-actions align="end">
            <button mat-dialog-close class="non-primary-button">Cancel</button>
            <button mat-button (click)="sendemail()" class="primary-button" [disabled]="!form.valid">Email me the link</button>
        </mat-dialog-actions>

        <!-- alternative -->
        <h4>
            <i>An alternative option is to copy the link by clicking the button below!</i><br />
            <button class="secondary-button" cdkCopyToClipboard="{{urlToSave}}" (click)="copytoclipboard()" [ngClass]="{'secondary-button-toggled': toggle}">{{copytoclipboardtext}}</button>
        </h4>

    </mat-dialog-content>

</form>
